const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdminApprovalFailure = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 320,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefdfd",
    d: "M-.5-.5h320v320H-.5z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M63.5 38.5q14.316-3.498 27 4.5a150 150 0 0 0-13-4 98.4 98.4 0 0 0-14-.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d9d9d",
    d: "M43.5 48.5q.814.09 1 1-6.916 7.677-1-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M253.5 59.5a36.7 36.7 0 0 1 13.5 5q1 2.5 0 5a311 311 0 0 1-18.5 32.5q-8.757 2.22-8.5-6.5a1220 1220 0 0 0 11-33q1.047-1.785 2.5-3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3a3a3",
    d: "M34.5 63.5q-.705 13.49 2.5 27-5.412-13.072-2.5-27",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f74f59",
    d: "M68.5 55.5q3.535-.245 7 .5.817 10.702-1.5 21.5-2.324 3.755-5 0a242 242 0 0 1-.5-22",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2e34",
    d: "M218.5 152.5a10.2 10.2 0 0 0-3-3q-1.913-6.41-8-9-12.435-6.777-27-5 .25-9.513-.5-19-5.888-4.12-7.5-11a76 76 0 0 0 .5-17q-6.864-4.36-10.5-11.5-9.69-2.553 0-2.5.38-3.49-2-6a32.8 32.8 0 0 0-12-5.5q-1.453-4.613-6-3-7.908 6.414-9.5 16.5a256 256 0 0 0 0 32q.36 3.528 2.5 6 .356 1.936-1 3-8.862-4.223-7.5-14 2.913-4.124 3.5-9a82 82 0 0 0-3.5-12 12.5 12.5 0 0 1 0-7l8-10q3.207-24.733 27.5-20.5a36.2 36.2 0 0 1 7 4q6.11 9.096 17 11l3.5 3.5a96.4 96.4 0 0 0 8 15q10.791-6.747 18 4 2.823 14.548-9.5 22.5-4.095 1.092-8-.5a189 189 0 0 1-6 11.5q.874 3.748 4 6a42.5 42.5 0 0 1 9.5 4.5l1 8 1.5 1.5q5.363.285 9.5 3.5.749 6.481.5 13",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M105.5 62.5q2.871 5.483 3 12a69.8 69.8 0 0 1-5.5 21 4.46 4.46 0 0 1-1.5-2q7.42-14.752 4-31",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1535f",
    d: "M70.5 83.5q9.226.904 4 8.5-11.25.294-4-8.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebb497",
    d: "M172.5 105.5a849 849 0 0 1-1-16q-3.952-1.46-6-5a29 29 0 0 1-4 5q-1.127 1.61-3 .5l-2-5q1.26-2.5-1.5-.5-1.067-2.8 1.5-4.5a175 175 0 0 1-3-3.5l2-2q-8.435-1.296-16-3-3.249-.105-1 2 3.233.752 5 3-3.86-.528-7 1.5 3.377-.31 7-.5-2.39 16.27 0 11 4.269-.463 4.5-5 1 2 2 0 1.212 3.118-.5 6-3.048 4.343-5 9.5 8.001 1.971 0 2-2.161-7.469-10-5.5a112 112 0 0 0 1 19q-2.14-2.472-2.5-6a256 256 0 0 1 0-32q1.592-10.086 9.5-16.5 4.547-1.613 6 3a32.8 32.8 0 0 1 12 5.5q2.38 2.51 2 6-9.69-.053 0 2.5 3.636 7.14 10.5 11.5a76 76 0 0 1-.5 17",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211418",
    d: "M139.5 85.5q2.322.481 2 3-4.121.147-2-3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#271511",
    d: "M143.5 76.5v1q-3.623.19-7 .5 3.14-2.028 7-1.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9a9a9",
    d: "M40.5 95.5q4.695 3.943 9 8.5-1 1-2 0-4.42-3.654-7-8.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#babcbb",
    d: "M81.5 108.5a4.93 4.93 0 0 1 3 .5q-12.306 4.37-25 1a56.4 56.4 0 0 1 11.5.5q5.64.02 10.5-2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M233.5 110.5q18.023-1.148 10 14.5-15.564 5.93-13.5-10.5a20.7 20.7 0 0 1 3.5-4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdbd9b",
    d: "M161.5 89.5a29 29 0 0 0 4-5q2.048 3.54 6 5 .437 8.205 1 16 1.612 6.88 7.5 11 .75 9.487.5 19-.23 8.802-5 16.5 1.202 5.53 6 3.5-.679 1.438-2 2.5 3.022 2.333 1 5.5a117 117 0 0 1-14 12 10.5 10.5 0 0 0-2.5-3q-1.693 2.462-4.5 3 1.965-2.471 4-5-1.291-3.617-4-6a157 157 0 0 0-6-12q-1.237-1.329-3-1a854 854 0 0 0-2 14.5q.022 2.077 1 3.5l4 5q-2.84-.822-5-3l-2 2q-4.026-2.54-8-5-7.79-3.648-7-12.5 4.268-7.819 5-17-.105-1.147-1-1.5a45 45 0 0 0-1-10 174 174 0 0 1-3-4q1.783-1.393 4-1 .201-2.687-1-5 1.356-1.064 1-3a112 112 0 0 1-1-19q7.839-1.969 10 5.5 8.001-.029 0-2 1.952-5.157 5-9.5 1.712-2.882.5-6-1 2-2 0-.231 4.537-4.5 5-2.39 5.27 0-11v-1q-1.767-2.248-5-3-2.249-2.105 1-2 7.565 1.704 16 3l-2 2a175 175 0 0 0 3 3.5q-2.567 1.7-1.5 4.5 2.76-2 1.5.5l2 5q1.873 1.11 3-.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30211a",
    d: "M161.5 89.5q-2.322-.481-2-3 4.121-.147 2 3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faaf8b",
    d: "M134.5 127.5a157 157 0 0 0 7-18.5l-.5-2.5-4 8q-.36-5.915 4-10 2.823.89 3 4a14.5 14.5 0 0 1 5.5-5q3.487 5.147 7-1 1.807 2.457 4 1a134 134 0 0 0 10.5 9q1 2.5 0 5-.434-2.316-2-4l-1 8-1-7-10-10q-1.03 3.63 1.5 6.5-2.457-.363-4.5-2.5-1 2 0 4 8.094 7.671 4 18a12.8 12.8 0 0 0-3-6l-1 2-1 17q-3.733-11.485 2-22 1-2 0-4l-5.5 7q-1.197-5.826-5-2-2.553-6.39 2.5-11-.207 2.985-1.5 6l1 2a43.3 43.3 0 0 0 5-9.5 10.2 10.2 0 0 0-2.5-4.5q-10.739 7.457-8 20a7.3 7.3 0 0 1-2-3l-1 1-1 11-1-6q-.575-.834-1.5-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f25760",
    d: "M180.5 135.5q14.565-1.777 27 5a194 194 0 0 0-7-1.5q-2 1 0 2a15.4 15.4 0 0 0-6 3q-5.892 6.654-13 11.5-4.798 2.03-6-3.5 4.77-7.698 5-16.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd4d59",
    d: "M180.5 136.5q7.786-.663 15 1.5a13.9 13.9 0 0 0-3 4q-3.82.101-6.5 2.5-2.295-2.13-5.5-3a53.7 53.7 0 0 0 9-2.5q-5.238.105-9-2.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#23292c",
    d: "M218.5 152.5a73.5 73.5 0 0 1 7.5 7q1.312 6.149-2.5 11a142 142 0 0 1-5-18",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee656d",
    d: "M215.5 149.5a10.2 10.2 0 0 1 3 3 142 142 0 0 0 5 18v3q-1.142-1.337-3-2-6.354 4.075-14 4 5.996-4.835 14-5 .428-2.682-1-5-1.393 1.783-1 4a4.93 4.93 0 0 1-3-.5 17.5 17.5 0 0 0 3-8.5 168 168 0 0 1-3-11",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa888c",
    d: "M103.5 173.5a8.4 8.4 0 0 0 .5 4l9.5 7.5q-5.868-1.791-10.5-6.5-.348 1.856-1.5 3 .098-4.392 2-8",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f34f59",
    d: "m82.5 181.5-3.5 7a46 46 0 0 0-5.5 6q-4.462 3.486-10 2.5-12.204-19.378.5-38.5 9.15-11.217 19-1 2.807 4.058 2.5 9a81 81 0 0 1-3 15",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f34f5a",
    d: "M48.5 221.5h-1q-14.175 1.038-21.5-11l-5-10q-2.366-22.632 17.5-11.5 16.045 12.942 10 32.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f3f4",
    d: "M263.5 251.5q-8.886 4.133-13.5 13a302.5 302.5 0 0 0-1.5 41h-22v-2a116.6 116.6 0 0 0-14-29q3.534-14.177-3-27.5 11.27 1.747 15.5-8.5a38 38 0 0 0 2.5-8q1.76-1.52 2-4a74.6 74.6 0 0 0 2-21q.239 11.407 5 22a37 37 0 0 0 4.5-2 156 156 0 0 0 10-19q7.968-12.62 20.5-5 1.995 6.06-.5 12a219 219 0 0 1-16.5 18.5q.282 2.822 3 3.5 5.022-.647 10 1.5 3.87 2.222 2.5 6.5-3.602 4.738-6.5 8",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee696e",
    d: "M106.5 233.5a309 309 0 0 1-3-4q1.077-9.91 3.5-20a25.6 25.6 0 0 1 5.5-6.5q1.703-1.124 3 .5-12.39 12.548-9 30",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb8e97",
    d: "M225.5 213.5q1 0 1 1a82 82 0 0 1 3 12q-.24 2.48-2 4a66.6 66.6 0 0 0-2-17",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e6e6",
    d: "M82.5 181.5q1.46 4.704 6.5 6a113 113 0 0 0 6 13 309 309 0 0 1 2.5 20 514 514 0 0 0 1.5-32q.575-.834 1.5-1-3.216 21.428 3 42a309 309 0 0 0 3 4q4.073 5.82 11 7.5 3.97.746 8 .5a68.2 68.2 0 0 1-1 14q-3.807 7.952-2.5 17 1.312 4.072 5.5 4v1l-4 22q.32 2.466-1 4.5 51.998.75 104 .5v1a8194 8194 0 0 1-181-1q13.275.49 26-1h1q24.243 1.742 49 .5a121 121 0 0 1-21-6q-6.56-2.57-11.5-7.5-2.4-3.891-.5-8a61.2 61.2 0 0 1 15-1q.255-1.983-1-3.5-12.167-4.172-19-15a13.9 13.9 0 0 1 3-4q5.595-2.859 12-3.5 2.148-.35 1.5-2A473 473 0 0 0 83.5 241q-2.142-.868-4 .5 1.451-4.418.5-9-2.684-2.594-6.5-2 7.603-2.516 16-2a135.3 135.3 0 0 0-11.5-29 12.9 12.9 0 0 1-.5-5h-4a46 46 0 0 1 5.5-6z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f14e59",
    d: "M25.5 220.5q15.77-.738 21.5 14a33.2 33.2 0 0 1-.5 14q-10.443 2.268-17.5-6-7.775-8.035-6-19a10.5 10.5 0 0 0 2.5-3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa4f5a",
    d: "M135.5 137.5q.895.353 1 1.5-.732 9.181-5 17-.79 8.852 7 12.5 1.188 2.636 4 4l2 5q.747-1.654 1-3 4.483.471 7 4a152.5 152.5 0 0 0-7 23q2.124 2.459 5 2.5a236 236 0 0 1 4-11.5q3.887-3.73 8 0 2.667 2.646 4 6-1.73 1.22 0 3l-1.5 1q-2.694-.62-5 0-.397 2.495 1.5 4.5a4.46 4.46 0 0 0-2 1.5q1.936 1.54 0 3a46.4 46.4 0 0 0-10-6q-2.276-.016-3.5-2l-1 1a467 467 0 0 1-8 26q-2.666 6.923-9.5 9-.939 5.543 3 2.5a36.2 36.2 0 0 0 11-11.5 741 741 0 0 0 9-23q4.473 2.961 9 6 1.025-.544 2-1 3.46-.168 6.5 3 1.473-1.888 1-4-4.482 1.866-6.5-3a25.6 25.6 0 0 1 7-5 336 336 0 0 1 10.5 22q.868 2.143-.5 4 1.763-.329 3 1a157 157 0 0 0 16.5 20 44 44 0 0 1 6.5-.5q3.09-2.24 1-5.5-23.568-15.066-34-41v-3q6.178.018 11.5-3 2.381 1.84 4-1-2.197 8.68 3.5 15 1.732 8.24 10 7 .441-10.125-4.5-19a18.5 18.5 0 0 1-.5-6q2.169-3.751 1.5-8-1.347 3.853-3.5 7-1.231-4.712-1.5-10-1.61 4.5-2.5 9-8.512 7.632-20 8a99 99 0 0 1-7-16.5q.735-3.755 4-6-.834-.575-1-1.5 7.383-5.37 14-12 2.022-3.167-1-5.5 1.321-1.062 2-2.5 7.108-4.846 13-11.5a15.4 15.4 0 0 1 6-3q-2-1 0-2 3.388.659 7 1.5 6.087 2.59 8 9a168 168 0 0 0 3 11 17.5 17.5 0 0 1-3 8.5 4.93 4.93 0 0 0 3 .5q-.393-2.217 1-4 1.428 2.318 1 5-8.004.165-14 5 7.646.075 14-4 1.858.663 3 2 4.2 16.013 8 32a74.6 74.6 0 0 1-2 21 82 82 0 0 0-3-12q1.72-12.022-10-17l-1 1q6.773 4.044 6.5 12 1.139 2.344 3.5 3a66.6 66.6 0 0 1 2 17 38 38 0 0 1-2.5 8q-4.23 10.247-15.5 8.5 6.534 13.323 3 27.5l-4 2q-14.204 3.032-29 1.5-6.538-1.045-12-3.5a16.64 16.64 0 0 0 6-5q7.606-2.286 15-6.5 1.292-4.303 5-7-3.102.025-5 3l-8 1a202 202 0 0 1-20.5 9.5 661 661 0 0 1-5-3 3.94 3.94 0 0 1-2 1q-6.213-3.13-12.5-.5-2 1 0 2 3.322.255 6 2 7.36.51 14 .5-1 0-1 1-7.686 1.993-16.5 2l-16.5-.5q-4.413-1.41-4-6 2.4-5.914 2-12.5 1.957-2.846 2-7-.005-3.788-1-7a32.5 32.5 0 0 1-8-.5q-6.927-1.68-11-7.5-3.39-17.452 9-30-1.297-1.624-3-.5a25.6 25.6 0 0 0-5.5 6.5q-2.423 10.09-3.5 20-6.216-20.572-3-42a19.2 19.2 0 0 0 1-6q1.152-1.144 1.5-3 4.632 4.709 10.5 6.5l-9.5-7.5a8.4 8.4 0 0 1-.5-4q1.78-30.772 32-36",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd363e",
    d: "m149.5 205.5 1 2a741 741 0 0 1-9 23 36.2 36.2 0 0 1-11 11.5q-3.939 3.043-3-2.5 6.834-2.077 9.5-9a467 467 0 0 0 8-26l1-1q1.224 1.984 3.5 2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc373f",
    d: "M172.5 203.5q10.432 25.934 34 41 2.09 3.26-1 5.5a44 44 0 0 0-6.5.5 157 157 0 0 1-16.5-20q-1.237-1.329-3-1 1.368-1.857.5-4a336 336 0 0 0-10.5-22q1.5-2 3 0",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc343d",
    d: "M196.5 193.5a18.5 18.5 0 0 0 .5 6q4.941 8.875 4.5 19-8.268 1.24-10-7a36.4 36.4 0 0 1-.5-12 45.5 45.5 0 0 0 5.5-6",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa858c",
    d: "M203.5 191.5q3.72 7.122 4 15.5-.018 12.973-5.5 24.5a128.6 128.6 0 0 0 3.5-24 67 67 0 0 0-2-16",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc8d90",
    d: "M149.5 205.5a46.4 46.4 0 0 1 10 6q1.487-.257 2 1-.975.456-2 1a1674 1674 0 0 0-9-6z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f15e65",
    d: "M196.5 193.5a45.5 45.5 0 0 1-5.5 6 36.4 36.4 0 0 0 .5 12q-5.697-6.32-3.5-15-1.619 2.84-4 1-5.322 3.018-11.5 3v3q-1.5-2-3 0a25.6 25.6 0 0 0-7 5q2.018 4.866 6.5 3 .473 2.112-1 4-3.04-3.168-6.5-3-.513-1.257-2-1 1.936-1.46 0-3a4.46 4.46 0 0 1 2-1.5q-1.897-2.005-1.5-4.5 2.306-.62 5 0l1.5-1q-1.73-1.78 0-3 .875 7.359 4 1 11.488-.368 20-8-.77 11.275 4 1 2.153-3.147 3.5-7 .669 4.249-1.5 8",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c23c42",
    d: "M226.5 214.5q0-1-1-1-2.361-.656-3.5-3 .273-7.956-6.5-12l1-1q11.72 4.978 10 17",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe8a8f",
    d: "M119.5 195.5q.09-.814 1-1 9.168 8.086 21 11.5-6.297.075-12-3a83.5 83.5 0 0 1-10-7.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b23339",
    d: "M194.5 192.5q-4.77 10.275-4-1 .89-4.5 2.5-9 .269 5.288 1.5 10",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bb363e",
    d: "M138.5 168.5q3.974 2.46 8 5l2-2q2.16 2.178 5 3 2.751 6.47 6 1 2.807-.538 4.5-3a10.5 10.5 0 0 1 2.5 3q.166.925 1 1.5-3.265 2.245-4 6a99 99 0 0 0 7 16.5q-3.125 6.359-4-1-1.333-3.354-4-6-4.113-3.73-8 0a236 236 0 0 0-4 11.5q-2.876-.041-5-2.5a152.5 152.5 0 0 1 7-23q-2.517-3.529-7-4-.253 1.346-1 3l-2-5q-2.812-1.364-4-4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff888c",
    d: "M206.5 175.5a94 94 0 0 0-8.5 8q1.9-6.143 8.5-8",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee8c8e",
    d: "M153.5 174.5q2.276.016 3.5 2 1.006-1.129 2.5-1-3.249 5.47-6-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba343d",
    d: "M159.5 164.5q2.709 2.383 4 6-2.035 2.529-4 5-1.494-.129-2.5 1-1.224-1.984-3.5-2l-4-5a135 135 0 0 1 10-5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f65158",
    d: "M159.5 164.5a135 135 0 0 0-10 5q-.978-1.423-1-3.5a854 854 0 0 1 2-14.5q1.763-.329 3 1a157 157 0 0 1 6 12",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4b57",
    d: "M73.5 230.5q3.816-.594 6.5 2 .951 4.582-.5 9-1.166 5.862-6 9-3.832 1.332-8 1v-10q1.45-7.418 8-11",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd0d1",
    d: "M57.5 271.5h-3a33.8 33.8 0 0 0-2-10.5q.666-2.643 1.5.5a55 55 0 0 0 2 7q1.565-24.554-8.5-47h1a127.6 127.6 0 0 1 6.5 19 366 366 0 0 1 4-28 6027 6027 0 0 1-2.5 36 168 168 0 0 1 1 23",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe9092",
    d: "M179.5 229.5a110 110 0 0 1-15.5 15 196 196 0 0 1-11.5-6.5q6.286 1.264 11.5 5.5 7.138-7.9 15.5-14",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eb7278",
    d: "M125.5 241.5q.995 3.212 1 7-.043 4.154-2 7a68.2 68.2 0 0 0 1-14",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe8a8f",
    d: "M131.5 253.5q.09-.814 1-1a356 356 0 0 1 22 12.5q-1.5 1-3 0a299 299 0 0 0-20-11.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deccce",
    d: "M65.5 241.5v10q4.168.332 8-1-3.203 2.804-8 2l-3.5 16-.5-3.5q3.175-11.758 4-23.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33c43",
    d: "m173.5 269.5-8 4a16.5 16.5 0 0 1-5-2q-6.64.01-14-.5-2.678-1.745-6-2-2-1 0-2 6.287-2.63 12.5.5a3.94 3.94 0 0 0 2-1 661 661 0 0 0 5 3 202 202 0 0 0 20.5-9.5l8-1q1.898-2.975 5-3-3.708 2.697-5 7-7.394 4.214-15 6.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da5460",
    d: "M124.5 255.5q.4 6.586-2 12.5-.413 4.59 4 6l16.5.5q8.814-.007 16.5-2 3.776 2.946 8 2 5.462 2.455 12 3.5 14.796 1.532 29-1.5-6.891 4.342-15.5 4a419 419 0 0 1-33.5-4q-15.768-1.786-32 0-4.188.072-5.5-4-1.307-9.048 2.5-17",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb8f92",
    d: "M173.5 269.5a16.64 16.64 0 0 1-6 5q-4.224.946-8-2 0-1 1-1 2.3 1.397 5 2z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d363c",
    d: "M159.5 276.5a422 422 0 0 0-32 1v-1q16.232-1.786 32 0",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80939b",
    d: "M42.5 277.5q1.356 1.063 1 3 13.01-.25 26 .5l-2 1q2.157.328 4 1.5a197 197 0 0 1-28 1 21.5 21.5 0 0 1-1-7",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95b4bd",
    d: "M43.5 285.5q14.01-.25 28 .5-13.491.75-27 .5v3q-1.401-1.602-1-4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2e34",
    d: "M212.5 274.5a116.6 116.6 0 0 1 14 29h-102q.401-2.398-1-4l4-22a422 422 0 0 1 32-1 419 419 0 0 0 33.5 4q8.609.342 15.5-4z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#375963",
    d: "M54.5 271.5h20a268 268 0 0 0-3 30q-1.083-.626-1.5-2-11.84 2.924-24.5 2a73 73 0 0 0-1-12v-3q13.509.25 27-.5a393 393 0 0 0-28-.5v-1q14.035.497 28-1a10.3 10.3 0 0 0-4-1.5l2-1q-12.99-.75-26-.5.356-1.937-1-3v-6zM263.5 251.5q17.886-2.479 26.5 13a302.5 302.5 0 0 1 1.5 41h-43a302.5 302.5 0 0 1 1.5-41q4.614-8.867 13.5-13",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edeff0",
    d: "M266.5 259.5q22.155.325 14.5 21-6.341 6.88-15.5 4.5-10.92-5.597-7.5-17.5 3.11-5.366 8.5-8",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24363e",
    d: "M71.5 301.5q1.257.512 1 2h-1q-12.54-.077-26 0-3.65-1.572 0-2 12.66.924 24.5-2 .417 1.374 1.5 2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000101",
    d: "M71.5 303.5q-12.725 1.49-26 1v-1q13.46-.077 26 0",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000100",
    d: "M123.5 299.5q1.401 1.602 1 4h102v1q-52.002.25-104-.5 1.32-2.034 1-4.5",
    style: {
      opacity: 1
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdminApprovalFailure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/admin-approval-failure.206a89a6.svg";